
export const getTarget = (url) => (url && url.length && url.substr(0, 4) !== 'http') ? '_self' : '_blank';

export const getPrice = (p) => {
    let val = parseFloat(p);
    if(Number.isNaN(val)) { return 0; }
    return Math.ceil(val);
};